import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { setCurrentQuestion } from "../../reducers/topic";

interface TimerState {
  timeLeft: number;
  startTime: number | null;
  fullTimer: number;
}

const initialState: TimerState = {
  timeLeft: 0,
  startTime: null,
  fullTimer: 0,
};

const timerSlice = createSlice({
  name: "timer",
  initialState,
  reducers: {
    setTimer(
      state,
      action: PayloadAction<{ fullTimer: number; startTime: number }>
    ) {
      state.fullTimer = action.payload.fullTimer;
      state.startTime = action.payload.startTime;
      state.timeLeft = action.payload.fullTimer;
    },
    updateTimer(state) {
      if (state.timeLeft > 0) {
        state.timeLeft -= 1;
      } else {
        state.timeLeft = 0;
      }
    },
    resetTimer(state) {
      state.timeLeft = state.fullTimer;
      state.startTime = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setCurrentQuestion, (state, action) => {
      const currentTime = Date.now();
      const startDate = new Date(
        action.payload.topicQuestion.startDate
      ).getTime();

      const duration = 57;
      state.fullTimer = duration;

      const elapsedTime = Math.floor((currentTime - startDate) / 1000);
      const newTimer = Math.max(0, duration - elapsedTime);

      state.fullTimer = duration;
      state.startTime = startDate;
      state.timeLeft = newTimer;
    });
  },
});

export const { setTimer, updateTimer, resetTimer } = timerSlice.actions;
export default timerSlice.reducer;
